<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeStart, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeStart.$touch()"
              @blur="$v.dateRangeStart.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeEnd, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeEnd.$touch()"
              @blur="$v.dateRangeEnd.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'current'"
          @itemChange="(e) => (selectedCurrent = e)"
          :label="'Cari'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="salesPersonCode"
          label="Plasiyer"
          clearable
          filled
          solo
          dense
          :items="salesPersonList"
          :item-text="item => item.name"
          :item-value="item => item.code"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'stock'"
          @itemChange="(e) => (selectedStock = e)"
          :label="'Stok'"
      >
      </search-select>
    </div>
    <div class="col-lg-3" v-if="erpSettings.userBranch">
      <v-select
          v-model="branchCodeValue"
          label="Şube Kodu"
          filled
          solo

          dense
          :items="branchList"
          item-value="code"
          item-text="name"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="reportDbName"
          label="Şirket Adı"
          filled
          solo
          dense
          :items="companyList"
          item-text="name"
          item-value="name"
      >

      </v-select>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>
</template>

<script>

import {formattedDate} from "@/momentHelper";
import {mapActions, mapMutations, mapState} from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMessages } from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  name: "CariPerformans",
  components: {SearchSelect},
  props:{
    reportType:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      selectedCurrent: null,
      currentSearchText: null,
      searchCurrentLoading: false,
      currentSearchResult:[],
      searchCurrentTimeout: null,
      selectedStock: null,
      stockSearchText: null,
      searchStockLoading: false,
      stockSearchResult:[],
      searchStockTimeout: null,
      branchCodeValue: 0,
      salesPersonCode: null,
      reportDbName: null
    }
  },

  validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
  },

  mounted() {
    this.fetchSalesPersonList({
      params: {

      },
      body: {

      }
    });
    this.fetchCompanyList({
      params: {

      },
      body: {

      }
    });
    this.getBranchList()
  },
  computed:{
    ...mapState("auth",["user"]),
    ...mapState("current",["salesPersonList"]),
    ...mapState("company",["companyList"]),
    ...mapState("company",['branchList']),
    ...mapState("settings", ["erpSettings"]),
  },
  methods:{
    ...mapActions("current", ["fetchSalesPersonList","fetchCurrentList"]),
    ...mapActions("company", ["fetchCompanyList"]),
    ...mapActions("stock", ["fetchStockList"]),
    ...mapActions("company",['fetchBranchList']),
    ...mapMutations("company",['setBranchList']),
    formattedDate,
    validationMessages,
    filterReport(){
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.filterRequestObject = {
          StartDate: this.dateRangeStart,
          FinishDate: this.dateRangeEnd,
          CurrentCode: this.selectedCurrent,
          StockCode: this.selectedStock,
          SalesPersonCode: this.salesPersonCode,
          ReportDbName: this.reportDbName
        };
        this.$emit("reportFilterChange",this.filterRequestObject);
      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    },
    async getBranchList(){
      await this.fetchBranchList({
        params:{},
        body:{}
      });
      let tempBranchList = this.branchList.slice();
      tempBranchList.unshift({code: 0, name: 'Tüm Şubeler'})
      this.setBranchList(tempBranchList);
    },
  },
}
</script>

<style scoped>

</style>